
export default {"notAvailable":"Esta categoría no está disponible en el catálogo proporcionado en el derecho actual"}
